import { FEATURE_FLAGS } from "../constants/featureFlags";

let useGenerativeGlobal = false;

export const useGenerativeVoiceGlobal = () => {
  return useGenerativeGlobal || FEATURE_FLAGS.UNIVERSAL_GENERATIVE_VOICE;
}

export const setUseGenerativeVoiceGlobal = (useGenerative) => {
  useGenerativeGlobal = useGenerative;
}

export const TTS_ENGINE_TYPE = {
  standard: 'standard',
  generative: 'generative',
};